import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import { UserRowRoleType } from '@modules/users/store/types';
import { mapUserTypeToUserRowRoleType } from '@modules/users/utils';
import { FormControl, Select, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { UserType } from 'v2/core/entities/user';
import { useGetUser } from 'v2/core/services/user';
import { UserRoleMenuItems } from '../UserRoleMenuItems';
import { ChangeDefaultRoleConfirmationModalContent } from './ChangeDefaultRoleConfirmationModalContent';

export const DefaultUserRolesSelect = () => {
  const [isUserRolesMenuOpen, setIsUserRolesMenuOpen] = useState(false);

  const {
    tenant: {
      dashboardSettings: { defaultUserType },
    },
  } = useGetUser();
  const { openModal } = useMuiModalContext();

  const defaultRoleType = mapUserTypeToUserRowRoleType(
    defaultUserType ?? UserType.Editor,
  );

  const [selectedUserRole, setSelectedUserRole] =
    useState<UserRowRoleType | null>(defaultRoleType);

  const onDefaultRoleChange = (role: UserRowRoleType) => {
    openModal({
      contentComponent: () => (
        <ChangeDefaultRoleConfirmationModalContent
          newRole={role}
          onChange={() => {
            setIsUserRolesMenuOpen(false);
            setSelectedUserRole(role);
          }}
        />
      ),
      modalProps: {
        fullWidth: true,
        maxWidth: 'sm',
        PaperProps: {
          elevation: 3,
        },
      },
    });
  };

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      spacing={3}
    >
      <Stack spacing={0.25} flex={3}>
        <Typography variant="body1">Default User Role</Typography>
        <Typography variant="caption" color="text.secondary">
          Unless invited with a different role, all new users will be assigned
          this role on sign-up
        </Typography>
      </Stack>
      <FormControl size="small" sx={{ display: 'flex', flex: 1 }}>
        <Select
          open={isUserRolesMenuOpen}
          onOpen={() => setIsUserRolesMenuOpen(true)}
          onClose={() => setIsUserRolesMenuOpen(false)}
          value={selectedUserRole}
          size="small"
          MenuProps={{
            PaperProps: {
              sx: {
                maxWidth: 500,
                whiteSpace: 'normal',
              },
            },
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
          }}
          renderValue={(role) => role}
        >
          <UserRoleMenuItems
            selectedRole={selectedUserRole}
            onChange={onDefaultRoleChange}
          />
        </Select>
      </FormControl>
    </Stack>
  );
};
